var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v(" Installation Status ")]),
          _c(
            "gg-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.items,
                  "footer-props": {
                    itemsPerPageOptions: this.pagination
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function fn(props) {
                      return [
                        _c("tr", [
                          _c("td", [_vm._v(_vm._s(props.item.domain))]),
                          _c(
                            "td",
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "pb-1",
                                  attrs: {
                                    small: "",
                                    color: _vm.statusColor(props.item.status)
                                  }
                                },
                                [_vm._v("mdi-circle")]
                              ),
                              _vm._v(" " + _vm._s(props.item.status) + " ")
                            ],
                            1
                          ),
                          _c(
                            "td",
                            [
                              props.item.status === "Installed"
                                ? _c(
                                    "gg-btn",
                                    {
                                      attrs: {
                                        text: "",
                                        loading: _vm.loading,
                                        disabled: _vm.loading
                                      },
                                      on: {
                                        click: function click($event) {
                                          return _vm.setUninstallSsl({
                                            id: _vm.id,
                                            domain: props.item.domain
                                          })
                                        }
                                      }
                                    },
                                    [_vm._v("Uninstall")]
                                  )
                                : _c(
                                    "gg-btn",
                                    {
                                      attrs: {
                                        text: "",
                                        loading: _vm.loading,
                                        disabled: _vm.loading
                                      },
                                      on: {
                                        click: function click($event) {
                                          return _vm.setInstallSsl({
                                            id: _vm.id,
                                            domain: props.item.domain
                                          })
                                        }
                                      }
                                    },
                                    [_vm._v("Install")]
                                  )
                            ],
                            1
                          )
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }